module.exports = __webpack_public_path__ + "img/icon_ellipsis.521736fc.svg";